import { EnumeratedSet, EnumeratedSetValue, IEnumeration } from 'utility-js-enumeration';

export interface IQuestionTypesEnum extends IEnumeration {
  FREE_TEXT: EnumeratedSetValue;
  CHOICE: EnumeratedSetValue;
  MULTIPLE: EnumeratedSetValue;
  isMultiple: (arg?: any) => boolean;
  isChoice: (arg?: any) => boolean;
  isFreeText: (arg?: any) => boolean;
}

angular.module('capability-ng-poll').factory('QuestionTypesEnum', (Enumeration: IEnumeration): any => {
  return Enumeration('QuestionTypesEnum', {
    FREE_TEXT: 'free_text',
    MULTIPLE: 'multiple',
    CHOICE: 'choice'
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/types/question_types.ts